// ABOUTME: Close icon for mobile navigation/modals with filled style
// ABOUTME: Supports className, size, and color customization

interface CloseMobileIconProps {
  className?: string
  size?: number
  color?: string
}

export const CloseMobileIcon = ({ className = "", size = 12, color = "#6B7280" }: CloseMobileIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.863728 0.863627C1.0325 0.694903 1.26138 0.600119 1.50003 0.600119C1.73868 0.600119 1.96755 0.694903 2.13633 0.863627L6.00003 4.72733L9.86373 0.863627C9.94675 0.777668 10.0461 0.709103 10.1559 0.661935C10.2657 0.614767 10.3838 0.58994 10.5033 0.588901C10.6228 0.587863 10.7413 0.610634 10.8519 0.655887C10.9625 0.70114 11.063 0.767967 11.1475 0.852471C11.232 0.936974 11.2988 1.03746 11.3441 1.14807C11.3893 1.25867 11.4121 1.37719 11.4111 1.49669C11.41 1.61619 11.3852 1.73429 11.338 1.84409C11.2909 1.95389 11.2223 2.0532 11.1363 2.13623L7.27263 5.99993L11.1363 9.86363C11.3003 10.0334 11.391 10.2607 11.3889 10.4967C11.3869 10.7327 11.2922 10.9584 11.1254 11.1253C10.9585 11.2921 10.7328 11.3868 10.4968 11.3888C10.2608 11.3909 10.0335 11.3002 9.86373 11.1362L6.00003 7.27253L2.13633 11.1362C1.96659 11.3002 1.73924 11.3909 1.50327 11.3888C1.26729 11.3868 1.04156 11.2921 0.874691 11.1253C0.707824 10.9584 0.613171 10.7327 0.611121 10.4967C0.60907 10.2607 0.699785 10.0334 0.863728 9.86363L4.72743 5.99993L0.863728 2.13623C0.695004 1.96745 0.60022 1.73857 0.60022 1.49993C0.60022 1.26128 0.695004 1.0324 0.863728 0.863627Z"
      fill={color}
    />
  </svg>
)
